import React from "react"
import PropTypes from "prop-types"
import styled from "styled-components"
import { message, Popconfirm } from "antd"
import { DeleteOutlined } from "@ant-design/icons"

import * as api from "../../../../api"

import { useStateValue } from "../../../_shared/context/AppStateStore"
import useRestTable from "../../../_shared/hooks/useRestTable.js"

import AppButton from "../../../_shared/components/AppButton"
import Table from "../../../_shared/components/Table"

import ColorPickerPopoverTag from "./ColorPickerPopoverTag"

//------------------------------------------------------------------------------

function Categories(props) {
  // -------------------------------------
  // Props destructuring
  // -------------------------------------

  // -------------------------------------
  // Hooks (e.g. useState, useMemo ...)
  // -------------------------------------

  const [{ token }] = useStateValue()

  const [
    categories,
    fetchCategories,
    isLoading,
    pagination,
    totalCategories,
  ] = useRestTable("/categories", token)

  // -------------------------------------
  // Effects
  // -------------------------------------

  // -------------------------------------
  // Component functions
  // -------------------------------------

  function getPaginationObject() {
    return {
      size: "small",
      total: totalCategories,
      current: pagination.current,
      pageSize: pagination.pageSize,
    }
  }

  function handleTableChange(pagination) {
    fetchCategories({ pagination })
  }

  async function handleCategoryColorSave(category, colorHex) {

    console.log("handleCategoryColorSave", colorHex)
    const body = {
      color: colorHex,
    }

    try {
      await api.updateCategory(category.id, body, token)

      fetchCategories()

      message.success("Colore aggiornato con successo")
    } catch (error) {
      console.error(error)
    }
  }

  async function handleDeleteCategory(categoryId) {
    try {
      await api.deleteResource("/categories", token, categoryId)

      fetchCategories()

      message.success("Categoria eliminata")
    } catch (error) {
      console.error(error)
    }
  }

  // -------------------------------------
  // Component local variables
  // -------------------------------------

  return (
    <div className={props.className}>
      <Table
        columns={getColumns(handleCategoryColorSave, handleDeleteCategory)}
        dataSource={categories}
        loading={isLoading}
        pagination={getPaginationObject()}
        onChange={handleTableChange}
      />
    </div>
  )
}

// ----------------------------------------------------------------------------
// Component PropTypes and default props
// ----------------------------------------------------------------------------

Categories.propTypes = {
  className: PropTypes.string.isRequired,
}

Categories.defaultProps = {}

// ----------------------------------------------------------------------------

const StyledCategories = styled(Categories)`
  & {
    .color-tag {
      width: 36px;
      height: 18px;
      border-radius: 4px;
    }

    .delete-btn {
      z-index: 2;
      pointer-events: all;
    }
  }
`
// ----------------------------------------------------------------------------

export default StyledCategories

// ----------------------------------------------------------------------------
// Table columns
// ----------------------------------------------------------------------------

function getColumns(handleCategoryColorSave, deleteCategory) {
  return [
    {
      title: "Nome",
      dataIndex: "name",
      key: "commercialName",
    },
    {
      title: "Colore",
      dataIndex: "color",
      key: "color",

      //eslint-disable-next-line
      render: (text, record) => {
        return (
          <ColorPickerPopoverTag
            color={text}
            onSave={(color) => handleCategoryColorSave(record, color)}
          />
        )
      },
    },
    {
      title: "",
      dataIndex: "id",
      key: "actions",
      //eslint-disable-next-line
      render: (id, post) => {
        return (
          post && (
            <Popconfirm
              title="Sei sicuro di voler eliminare la categoria?"
              onConfirm={() => deleteCategory(id)}
              okText="Si"
              cancelText="No"
            >
              <AppButton
                className="delete-btn"
                uxType="warning"
                onClick={(event) => {
                  event.stopPropagation()
                }}
              >
                <DeleteOutlined />
              </AppButton>
            </Popconfirm>
          )
        )
      },
    },
  ]
}
